import { Outlet } from 'react-router-dom'

import { RESOURCE_TYPE } from 'modules/core/components/ActivityLog/ActivityEventsSidepanel'
import { useActivityLogPanel } from 'modules/core/components/ActivityLog/useActivityLogPanel'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import legalEntities from 'modules/core/store/collections/legalEntities'

import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import CollectionsBootstrap from 'modules/legal_entities/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  const { id: entityId } = useStrictParams<'id'>()
  const { loading, error } = useAsyncData(
    () => Promise.all([employeeGroups.fetch(), legalEntities.fetch()]),
    []
  )
  const legalEntity = legalEntities.get(String(entityId))
  const { onViewActivity, panel } = useActivityLogPanel({
    resourceId: legalEntity ? String(legalEntity.id) : undefined,
    resourceType: RESOURCE_TYPE.LegalEntity,
    resourceName: legalEntity?.name,
  })

  return (
    <CollectionsBootstrap>
      <Outlet
        context={{
          loading,
          error: !!error,
          legalEntity,
          onViewActivity,
        }}
      />
      {panel}
    </CollectionsBootstrap>
  )
}

export default RootPage
